module.exports = __webpack_public_path__ + "static/media/tree.97b41067.png";